export default "__VITE_ASSET__DKXhyaVD__"